(function($) {

    'use strict';

    function Blocklink() {

        var self = this,
        $el = null,

        options = {
            'example': null
        };


        /**
        * Public constructor
        * @param  {Object} opts Options
        */
        self.initialize = function(opts) {
            //extends options
            for (var i in opts) { options[i] = opts[i]; }

            //console.log('BlockLink');

            // Caching
            $el = options.$el;

            $el.on('click', function(e) {

                var $link = $(this).find('a').not('.js-ignoreBlockLink');

                if( $link.length ) {
                    if( ($link.attr('target') && $link.attr('target') === '_blank') ||
                    e.ctrlKey ||
                    e.button === 1) {
                        window.open( $link.attr('href') );
                    }
                    else if (e.button === 0) {
                        document.location.href = $link.attr('href');
                    }
                }
                return false;
            })
            .on('click', '.js-ignoreBlockLink', function(e) {

                e.stopPropagation();
            });
        };

        self.initialize.apply(self, arguments);
        return self;
    }

    /* Namespace declaration */
    window.Blocklink = Blocklink;

}(jQuery));
